/* global axios */
import ApiClient from './ApiClient';

class CarBooking extends ApiClient {
  constructor() {
    super('car_booking', { accountScoped: true });
  }

  base(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/car_booking`;
  }

  locations(conversationId, q) {
    return axios.get(`${this.base(conversationId)}/locations`, {
      params: { q },
    });
  }

  ratePlans(conversationId) {
    return axios.get(`${this.base(conversationId)}/rate_plans`);
  }

  schedule(conversationId, code) {
    return axios.get(`${this.base(conversationId)}/schedule`, {
      params: { code },
    });
  }

  prefill(conversationId) {
    return axios.post(`${this.base(conversationId)}/prefill`);
  }

  search(conversationId, search) {
    return axios.post(`${this.base(conversationId)}/search`, { search });
  }

  share(conversationId, tokens) {
    return axios.post(`${this.base(conversationId)}/share`, { tokens });
  }

  book(conversationId, payload) {
    return axios.post(`${this.base(conversationId)}/book`, payload);
  }

  cancel(conversationId, bookingId) {
    return axios.post(
      `${this.base(conversationId)}/bookings/${bookingId}/cancel`
    );
  }

  quote(conversationId, payload) {
    return axios.post(`${this.base(conversationId)}/quote`, payload);
  }

  shareQuote(conversationId, payload) {
    return axios.post(`${this.base(conversationId)}/share_quote`, payload);
  }

  equipment(conversationId, params) {
    return axios.get(`${this.base(conversationId)}/equipment`, { params });
  }

  modify(conversationId, bookingId, changes) {
    return axios.post(
      `${this.base(conversationId)}/bookings/${bookingId}/modify`,
      { changes }
    );
  }
}

export default new CarBooking();
